import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const baseURL = import.meta.env.VITE_API_URL;

const Register = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [alerts, setAlerts] = useState(false);
  const [pesan, setPesan] = useState("");
  const [businesses, setBusinesses] = useState([]);
  const [selectedBusinessCodes, setSelectedBusinessCodes] = useState([]);
  const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);
  const [role, setRole] = useState("");

  const businessAuthority = localStorage.getItem("businessAuthorities");
  const branchAuthority = localStorage.getItem("branchAuthorities");
  console.log("businessAuthority", businessAuthority);
  console.log("branchAuthority", branchAuthority);

  useEffect(() => {
    axios
      .get(`${baseURL}/get/BusinessBranch`)
      .then((response) => {
        const branchAuthorityArray = branchAuthority.split(",");
        const businessAuthorityArray = businessAuthority.split(",");

        const branchAuthorityObject = branchAuthorityArray.reduce(
          (acc, item) => {
            const [businessCode, branchCode] = item.split(";");
            acc[businessCode] = acc[businessCode] || [];
            acc[businessCode].push(branchCode);
            return acc;
          },
          {}
        );

        const filteredBusinessBranch = response.data.filter((item) => {
          const businessCode = item.BusinessCode;
          const branchCode = item.BranchCode;

          return (
            businessAuthorityArray.includes(businessCode) &&
            branchAuthorityObject[businessCode] &&
            branchAuthorityObject[businessCode].includes(branchCode)
          );
        });

        console.log("filteredBusinessBranch", filteredBusinessBranch);

        setBusinesses(filteredBusinessBranch);
      })
      .catch((error) => {
        console.log("Error fetching business data", error);
      });
  }, []);
  const handleBusinessBranchChange = (event) => {
    const { value, checked } = event.target;
    const [businessCode, branchCode] = value.split(";");

    if (checked) {
      setSelectedBusinessCodes((prev) => [...prev, businessCode]);
      setSelectedBranchCodes((prev) => [
        ...prev,
        `${businessCode};${branchCode}`,
      ]);
    } else {
      setSelectedBusinessCodes((prev) =>
        prev.filter((code) => code !== businessCode)
      );
      setSelectedBranchCodes((prev) =>
        prev.filter((code) => code !== `${businessCode};${branchCode}`)
      );
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      setPesan("Passwords do not match");
      setAlerts(true);
      return;
    }

    if (role === "") {
      setPesan("Please select a role");
      setAlerts(true);
      return;
    }

    const businessAuthority = [...new Set(selectedBusinessCodes)].join(",");
    const branchAuthority = selectedBranchCodes.join(", ");

    axios
      .post(`${baseURL}/user/register`, {
        UserName: username,
        UserPwd: password,
        CfmPwd: confirmPassword,
        BusinessAuthority: businessAuthority,
        BranchAuthority: branchAuthority,
        Role: role.trim().toUpperCase(),
      })
      .then((response) => {
        setAlerts(false);
        navigate("/");
      })
      .catch((error) => {
        setPesan("Registration failed");
        setAlerts(true);
      });
  };
  return (
    <section className="bg-white">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0 mt-8">
        <a
          href="#"
          className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white"
        >
          <img className="w-60 h-60 mr-2" src="/img/MMG.png" alt="logo MMG" />
        </a>
        <h1
          className="mb-8 text-2xl font-bold leading-tight tracking-tight
         text-blue-900 md:text-4xl dark:text-white"
        >
          MAJU MOTOR GROUP
        </h1>
        <div className="w-full bg-gray-300 rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            {alerts && (
              <div
                className="p-4 mb-4 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300"
                role="alert"
              >
                <span className="font-medium">{pesan}</span> <br />
              </div>
            )}
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
              Create an account
            </h1>
            <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="username"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Username
                </label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Your username"
                  required
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="role"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Role
                </label>
                <select
                  id="role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  placeholder="Select Role"
                  required
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value="">Select Role</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                </select>
              </div>
              <div>
                <label
                  htmlFor="businessBranch"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Branch
                </label>
                <div
                  className="bg-gray-50 border border-gray-300 rounded-lg p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  style={{ maxHeight: "90px", overflowY: "auto" }}
                >
                  {businesses.map((business) => (
                    <div
                      key={business.BranchCode}
                      className="flex items-center"
                    >
                      <input
                        type="checkbox"
                        id={business.BranchCode}
                        value={`${business.BusinessCode};${business.BranchCode}`}
                        onChange={handleBusinessBranchChange}
                        className="mr-2"
                      />
                      <label htmlFor={business.BranchCode}>
                        {`${business.NamaCabang}`}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="••••••••"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="confirmPassword"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  id="confirmPassword"
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="••••••••"
                  required
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
              <button
                type="submit"
                className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                Register
              </button>{" "}
              <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                Back to Home?{" "}
                <a
                  href="/home"
                  className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Click Here
                </a>
              </p>
              {/* <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                Already have an account?{" "}
                <a
                  href="/"
                  className="font-medium text-primary-600 hover:underline dark:text-primary-500"
                >
                  Sign in
                </a>
              </p> */}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Register;
